/**
 * @generated SignedSource<<4bf2d71834b3971b0892ca146087256b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteNodeOption_deleteAnnouncement_Mutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type DeleteNodeOption_deleteAnnouncement_Mutation$data = {
  readonly deleteAnnouncement: {
    readonly announcementDeletedId: string;
  } | null;
};
export type DeleteNodeOption_deleteAnnouncement_Mutation = {
  response: DeleteNodeOption_deleteAnnouncement_Mutation$data;
  variables: DeleteNodeOption_deleteAnnouncement_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "announcementDeletedId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteNodeOption_deleteAnnouncement_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AnnouncementsDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "deleteAnnouncement",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeleteNodeOption_deleteAnnouncement_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AnnouncementsDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "deleteAnnouncement",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "announcementDeletedId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4d2423494e801269342cb231158eb686",
    "id": null,
    "metadata": {},
    "name": "DeleteNodeOption_deleteAnnouncement_Mutation",
    "operationKind": "mutation",
    "text": "mutation DeleteNodeOption_deleteAnnouncement_Mutation(\n  $id: ID!\n) {\n  deleteAnnouncement(input: {id: $id}) {\n    announcementDeletedId\n  }\n}\n"
  }
};
})();

(node as any).hash = "165b0062186dfc0974edacc6a37affd0";

export default node;
